export default __webpack_public_path__ + "static/przemysław-białkowski-cc75510c9f105fc81722943b653a14b1.png";